
import './App.css';
import Aos from 'aos';
import React, { useEffect, useState } from 'react';
import './linkedin1.png';
import Modal from 'react-bootstrap/Modal';
function App() {
  const [showProjectModal, setShowProjectModal] = useState(false);
const [selectedProject, setSelectedProject] = useState(null);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('portfolio-theme') || 'dark');
  const [typedRole, setTypedRole] = useState('');
  const [portfolioFilter, setPortfolioFilter] = useState('all');

  useEffect(() => {
    Aos.init({ duration: 700, once: true });
    const handleScroll = () => setShowScrollTop(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  useEffect(() => {
    const roles = ['Furniture Designer', 'Interior Designer', 'Product Designer', '3D Modeling Artist'];
    let roleIndex = 0;
    let characterIndex = 0;
    let deleting = false;
    let timer;

    const typeRole = () => {
      const role = roles[roleIndex];

      if (!deleting) {
        characterIndex += 1;
        setTypedRole(role.slice(0, characterIndex));
        if (characterIndex === role.length) {
          deleting = true;
          timer = setTimeout(typeRole, 1600);
          return;
        }
      } else {
        characterIndex -= 1;
        setTypedRole(role.slice(0, characterIndex));
        if (characterIndex === 0) {
          deleting = false;
          roleIndex = (roleIndex + 1) % roles.length;
        }
      }

      timer = setTimeout(typeRole, deleting ? 45 : 90);
    };

    timer = setTimeout(typeRole, 300);
    return () => clearTimeout(timer);
  }, []);
  const projects = [
  {
    title: "Custom Kitchen with TV Unit",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/kitchenicon.png",
    modalImg: "projects/custom-kitchen/project-board.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom kitchen combining functionality, aesthetics and space optimization.
The project includes a storage wall, a multifunctional central island, a sink area under the window, upper cabinets with glass display units, a space for the washing machine and an integrated TV unit.
The combination of light-colored facades, warm wood, stone-effect countertop and LED lighting creates a modern, soft and elegant atmosphere.
This work illustrates my ability to design a compact, practical and visually coherent space.
`,
    link: "https://www.behance.net/gallery/252294199/CUSTOM-KITCHEN-WITH-TV-UNIT",
    linkLabel: "View project on Behance →",
  },
    {
    title: "Custom Entryway Console",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/consoleicon.png",
    modalImg: "projects/TVconsole.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom entryway console combining aesthetics, functionality and space enhancement.
The project features a decorative wall structured with wood panels, PVC wall coverings and vertical textured elements to create an elegant and contemporary composition.
The PVC wall covering provides a refined finish, easy maintenance and a modern decorative solution, while enhancing the visual impact of the wall.
The composition is completed with a slim console, an organic mirror and integrated lighting that highlight the entrance area.
`,
    link: "https://www.behance.net/gallery/252590027/Custom-Entryway-Console",
    linkLabel: "View project on Behance →",
  },
      {
    title: "COMPLETE HOUSE – CUSTOM INTERIOR DESIGN",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/houseicon.png",
    modalImg: "projects/Housefull.png",
    cardClass: "interior-project-cover",
    description: `This complete house interior design project presents a modern, warm and harmonious atmosphere.
The layout includes several living spaces: the entrance, living room, open kitchen, circulation area, bedroom and bathroom. Each space was designed to ensure comfort, functionality and visual coherence.
The combination of warm wood, neutral tones, soft textures, custom-made furniture and integrated lighting creates an elegant, contemporary and welcoming atmosphere.
This work illustrates my ability to design a complete interior project, organize spaces in a fluid way and produce realistic renderings to present the overall atmosphere of a home.
`,
    link: "https://www.behance.net/gallery/252595351/COMPLETE-HOUSE-CUSTOM-INTERIOR-DESIGN",
    linkLabel: "View project on Behance →",
  },
        {
    title: "Custom Kitchen",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/CkitchenIcon.png",
    modalImg: "projects/CustomKitchen.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom kitchen combining functionality, aesthetics and user comfort.
The project includes multiple storage units, a tall cabinet for built-in appliances, an optimized work area and a central island with a dining space.
The combination of beige facades, warm wood, a light countertop and LED lighting creates a modern, elegant and welcoming atmosphere.
The layout supports smooth circulation and practical organization of the space.
`,
    link: "https://www.behance.net/gallery/252595599/Custom-Kitchen",
    linkLabel: "View project on Behance →",
  },
          {
    title: "Custom Bathroom ",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/bathicon.png",
    modalImg: "projects/bathroom.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom bathroom combining aesthetics, comfort and functionality.
The project features a walk-in shower with a built-in niche, a wall-hung vanity with storage, a wall-hung toilet and recessed shelves for optimized storage.
The use of large-format tiles, neutral tones and matte black fixtures creates a modern, minimalist and timeless atmosphere.
The layout ensures smooth circulation and a clean, organized space.
`,
    link: "https://www.behance.net/gallery/252596003/Custom-Bathroom",
    linkLabel: "View project on Behance →",
  },
            {
    title: "CUSTOM ENTRYWAY CONSOLE",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/tv2icon.png",
    modalImg: "projects/tv2.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom entryway console combining aesthetics, functionality and space enhancement.
The project features a decorative wall with wood panels, vertical textured cladding and a slim console with decorative elements to create an elegant and welcoming atmosphere.
The combination of warm wood, light textures and a black metal base brings a modern, refined and harmonious composition.
`,
    link: "https://www.behance.net/gallery/252596193/CUSTOM-ENTRYWAY-CONSOLE?platform=direct",
    linkLabel: "View project on Behance →",
  },
              {
    title: "CUSTOM TV UNIT",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/customtv2icon.png",
    modalImg: "projects/customtv2.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom TV unit combining storage, functionality and aesthetics.
The project includes a wall panel in warm wood finish, a floating drawer unit with an open niche, and a tall display cabinet with a glass door and integrated lighting to create a modern and elegant composition.
The combination of wood texture, fabric interior and LED lighting brings a warm, sophisticated and timeless atmosphere.
`,
    link: "https://www.behance.net/gallery/252596361/Custom-TV-Unit?platform=direct",
    linkLabel: "View project on Behance →",
  },
                {
    title: "CUSTOM DRESSING WITH VANITY AREA",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/dressingicon.png",
    modalImg: "projects/dressing.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom dressing with an integrated vanity area, combining storage, functionality and aesthetics.
The project includes a wardrobe, a vanity unit with drawers and a vertical mirror to optimize the space while creating an elegant and practical composition.
The combination of light-colored facades, warm wood and simple details brings a modern, soft and refined atmosphere.
`,
    link: "https://www.behance.net/gallery/252596525/Custom-Dressing-with-vanity-area?platform=direct",
    linkLabel: "View project on Behance →",
  },
                  {
    title: "CUSTOM TV UNIT",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/tvuniticon.png",
    modalImg: "projects/tvunit.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom TV unit combining storage, functionality and aesthetics. The project includes a vertical cabinet, open shelves and a floating drawer unit to optimize the space while creating a clean and modern composition. The combination of light fabric texture, wood and stone panel with integrated LED lighting brings a sophisticated and elegant atmosphere.
`,
    link: "https://www.behance.net/gallery/252596785/Custom-TV-unit?platform=direct",
    linkLabel: "View project on Behance →",
  },
                  {
    title: "CUSTOM DRESSING WITH VANITY AREA",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/dressing2icon.png",
    modalImg: "projects/dressing2.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom dressing with an integrated vanity area, combining storage, functionality and aesthetics. The project includes a spacious wardrobe, a floating vanity unit and an organic backlit mirror to optimize the space while creating an elegant and practical composition. The combination of dark wood, light-colored facades and gold handles brings a modern, warm and refined atmosphere.
`,
    link: "https://www.behance.net/gallery/252596947/CUSTOM-DRESSING-WITH-VANITY-AREA?platform=direct",
    linkLabel: "View project on Behance →",
  },
          {
    title: "CUSTOM OFFICE AREA",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/officeicon.png",
    modalImg: "projects/office.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom office area combining storage, functionality and aesthetics. The project includes wall-mounted cabinets, open shelves and a side bookcase to optimize the space while creating a comfortable and organized workspace. The combination of wood, light-colored facades and black details brings a modern, elegant and warm atmosphere.
`,
    link: "https://www.behance.net/gallery/252597113/Custom-Office-Area?platform=direct",
    linkLabel: "View project on Behance →",
  },
            {
    title: "CUSTOM LAUNDRY AREA",
    tools: "SketchUp · D5 Render",
    category: "interior",
    cardImg: "projects/laundryicon.png",
    modalImg: "projects/laundry.png",
    cardClass: "interior-project-cover",
    description: `Design of a custom laundry area combining functionality and aesthetics. The project includes optimized storage for the washing machine and cleaning products, with a practical and discreet organization. The combination of wood and light-colored facades creates a warm and modern atmosphere.
`,
    link: "https://www.behance.net/gallery/252597249/CUSTOM-LAUNDRY-AREA?platform=direct",
    linkLabel: "View project on Behance →",
  },
      {
    title: "Parametric Entryway Wardrobe",
    tools: "AutoCAD",
    cardImg: "projects/entrywardicon.png",
    modalImg: "projects/entryward.png",
description: `This project presents the design and 3D modeling of a contemporary parametric entryway wardrobe that combines functionality, organization, and modern aesthetics in a single furniture piece. The design was developed to optimize entrance spaces while providing practical storage solutions for everyday use.
The wardrobe integrates multiple functions, including closed storage cabinets, open decorative shelves, a coat-hanging area, shoe storage compartments, and accessory organization spaces. Its rounded edges and balanced geometric composition create a soft and elegant visual identity, while the combination of white surfaces and dark wood textures adds warmth and sophistication to the overall design.
The project follows a parametric design approach, allowing the dimensions, internal compartments, and functional elements to be easily modified according to user needs and spatial constraints. This flexible methodology ensures both ergonomic efficiency and visual harmony while enabling the creation of multiple design variations from the same concept.
The 3D model was created using SketchUp, which allowed accurate control of proportions, furniture details, and structural composition. The final visualization was produced with V-Ray, used to generate realistic materials, lighting effects, shadows, and reflections in order to achieve a professional photorealistic render.
This project helped me strengthen my skills in parametric furniture design, 3D modeling, material composition, and architectural visualization, while also improving my understanding of functional interior furniture development.
`,

    link: "https://www.behance.net/portfolio/editor?project_id=252597773",
    linkLabel: "Find it on Behance →",
  },
    {
    title: "Storage Unit – 3D Design and Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/wardicon.png",
    modalImg: "projects/ward2.png",
description: `Design and 3D modeling of a functional storage unit created in AutoCAD, featuring an optimized internal organization to facilitate classification and accessibility. The project highlights a compact structure, clearly defined compartments, and a practical opening system, ensuring ergonomic everyday use.
The simple lines and sober color palette reinforce the modern and timeless character of the furniture. This work demonstrates my ability to design utility furniture, master element assembly, and produce clear, precise, and professional 3D visualizations.`,

    link: "https://www.behance.net/portfolio/editor?project_id=252597555",
    linkLabel: "Find it on Behance →",
  },

  {
    title: "Multifunctional Desk – 3D Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/chaise-removebg-preview.png",
    modalImg: "projects/Desk1.png",
description: `This project represents a multifunctional desk that I fully designed and modeled in 3D using AutoCAD. The goal was to create an ergonomic, compact, and aesthetic piece of furniture adapted to a modern workspace.

The design combines several features: a main work surface with curved lines for improved comfort, integrated upper shelves for document and object storage, a side cabinet with an ergonomic handle, and lower drawers providing additional storage space.

The choice of colors and materials aims to create a balance between simplicity, modernity, and warmth, while highlighting the volumes and details of the furniture.

This project allowed me to develop my skills in 3D modeling, furniture design, proportion management, and project visualization. It demonstrates my ability to independently design a product from the initial concept to the final representation.`,

    link: "https://www.behance.net/gallery/241986851/Modlisation-dun-Bureau-multifonction",
    linkLabel: "Find it on Behance →",
  },
  {
    title: "Storage Wardrobe – 3D Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/wardrobe1-removebg-preview.png",
    modalImg: "projects/Wardrobe.png",
    description:
      
        `This project consists of the design and 3D modeling of a storage wardrobe entirely created using AutoCAD. The objective was to design a functional, elegant piece of furniture adapted to modern domestic use.
The wardrobe is organized into several compartments to optimize interior space:
A hanging section with a clothing rail,
Side shelves for folded storage,
Integrated drawers for accessories and small items.
The choice of dark wood combined with golden accents gives the wardrobe a warm and refined visual identity. The interior layout was designed to provide practicality, ergonomics, and aesthetic balance.
This project helped me strengthen my skills in furniture design, interior space organization, 3D modeling, and product visualization. It reflects my ability to independently design a complete piece of furniture, from structural concept to functional details.`
   ,
    link: "https://www.behance.net/gallery/241987165/Modelisation-dun-Armoire-de-rangement?tracking_source=project_owner_other_projects",
    linkLabel: "Find it on Behance →",
  },
    {
    title: "Table – 3D Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/width_458-removebg-preview.png",
    modalImg: "projects/table1.png",
    description:
      
        `Design and 3D modeling of an original table created in AutoCAD, characterized by a sculptural structure composed of curved legs forming a dynamic and balanced composition. The circular tabletop brings softness and harmony, while the metal base reinforces stability and the visual identity of the furniture.
The contrast between organic forms and materials highlights the contemporary character of the project. The sober color palette emphasizes the elegance and modernity of the overall design.
This work demonstrates my ability to design creative furniture, master complex form modeling, and propose objects with strong aesthetic and functional value.`
   ,
    link: "https://www.behance.net/gallery/242206841/Table-Conception-et-modlisation-3D-sous-AutoCAD",
    linkLabel: "Find it on Behance →",
  },
      {
    title: "Design Base – Conceptual Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/socle1.png",
    modalImg: "projects/socle.png",
    description:
      
        `This project presents the design of a contemporary geometric base, fully modeled in AutoCAD. The concept is built on the combination of circular shapes with vertical and diagonal lines, creating a structure that is light, dynamic, and architectural.
The base is designed as a versatile support that can be used for a decorative object, a sculpture, or an exhibition element. The graphic composition highlights the balance between stability and visual transparency while maintaining a strong aesthetic identity.
The choice of a dark and uniform color emphasizes the purity of the lines and reinforces the modern character of the design. This project demonstrates my ability to create abstract forms, master geometric modeling, and explore minimalist design concepts.
This work helped me develop my creativity, precision in volume construction, and understanding of three-dimensional structures.`
   ,
    link: "https://www.behance.net/gallery/241987337/Modelisation-dun-Socle",
    linkLabel: "Find it on Behance →",
  },
   {
    title: "chair Lounge – 3D Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/width_550-removebg-preview.png",
    modalImg: "projects/chair_loung.png",
    description:
      
        `This project presents the design and 3D modeling of a contemporary ergonomic chaise lounge, entirely created in AutoCAD. The curved structure naturally follows the body posture, providing optimal comfort while maintaining an elegant aesthetic.
The chair is composed of a wooden base with smooth flowing lines, combined with padded cushions arranged in segments to improve support for the back and legs. The inclined backrest enhances the feeling of relaxation, while the discreet legs ensure overall stability.
The color palette, based on warm and neutral tones, was selected to highlight the softness of the shapes and the modern appearance of the furniture. This project demonstrates my ability to combine ergonomics, design, and precise modeling.
This work allowed me to develop my skills in furniture design, organic modeling, material management, and product visualization.`
   ,
    link: "https://www.behance.net/gallery/242207299/Chaise-longue-Modlisation-3D-sous-AutoCAD",
    linkLabel: "Find it on Behance →",
  },
     {
    title: "chair Lounge – 3D Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/chairlogo.png",
    modalImg: "projects/chair2.png",
    description:
      
        `This project presents the design and 3D modeling of a contemporary chair, entirely created in AutoCAD. The structure is based on an exposed metal frame, ensuring strength, stability, and visual lightness.
The seat and backrest, with strong geometric shapes, create a dynamic contrast with the structure. The inclined backrest provides ergonomic comfort while giving the chair a strong and modern identity. The integrated armrests enhance functionality and user comfort.
The color palette, composed of deep and contrasting tones, was chosen to emphasize the graphic character of the design and highlight the furniture volumes.
This project allowed me to develop my skills in furniture design, structural modeling, part assembly, and product visualization. It demonstrates my ability to transform a concept into a functional and aesthetic object.`
   ,
    link: "https://www.behance.net/gallery/242208011/Chaise-design-Modlisation-3D-sous-AutoCAD",
    linkLabel: "Find it on Behance →",
  },
     {
    title: "TV Unit – 3D Modeling in AutoCAD",
    tools: "AutoCAD",
    cardImg: "projects/tv-removebg-preview.png",
    modalImg: "projects/tv_unit.png",
    description:
      
        `Design and 3D modeling of a contemporary TV unit created in AutoCAD. The project highlights a balanced structure combining wood and metal, offering stability, elegance, and functionality. The geometric lines and clean volumes emphasize a modern aesthetic, while the integrated storage spaces optimize everyday use.
The color palette, composed of natural and contrasting tones, strengthens the visual identity of the furniture. This work demonstrates my mastery of 3D modeling, furniture design, technical assembly, and product presentation through both an aesthetic and functional approach.`
   ,
    link: "https://www.behance.net/gallery/242208451/Meuble-TV-Modlisation-3D-sous-AutoCAD",
    linkLabel: "Find it on Behance →",
  },
    {
    title: "TV Unit – 3D Design and Modeling in SketchUp",
    tools: "SketchUp",
    cardImg: "projects/tvsktchlogo.png",
    modalImg: "projects/tvsketch.png",
    description:
      
        ` 
Design and 3D modeling of a contemporary TV unit created in SketchUp, highlighting a compact and functional structure with clean geometric lines. The project integrates optimized storage spaces as well as a central area dedicated to the screen, promoting ergonomics and visual clarity.
The work on wood textures enhances the warm and elegant character of the furniture while emphasizing volumes and proportions. This project demonstrates my ability to design functional furniture, master 3D modeling in SketchUp, and transform a concept into a realistic, aesthetic object suitable for domestic use`
   ,
    link: "https://www.behance.net/gallery/242241529/meuble-tv",
    linkLabel: "Find it on Behance →",
  },
   {
    title: "Logo – Graphic Design in Adobe Illustrator",
    tools: "Adobe Illustrator",
    cardImg: "projects/logoicon1.png",
    modalImg: "projects/logo1.png",
    description:
      
        ` Creation of a contemporary logo designed in Adobe Illustrator, based on an organic composition of fluid shapes evoking lightness, harmony, and balance. The combination of blue and violet provides a modern visual identity, symbolizing creativity, confidence, and innovation.
The clean, curved lines enhance the readability of the symbol while giving it an elegant and dynamic expression. This minimalist design allows easy adaptation across various communication media.
This project demonstrates my ability to create strong visual identities, master vector design, and translate abstract values into an aesthetic and memorable logo.`
   ,
    link: "https://www.behance.net/gallery/242241613/logo",
    linkLabel: "Find it on Behance →",
  },
     {
    title: "Logo – Graphic Design in Adobe Illustrator",
    tools: "Adobe Illustrator",
    cardImg: "projects/logoicon2.png",
    modalImg: "projects/logo2.png",
    description:
      
        ` Creation of a symbolic logo representing a stylized phoenix, designed in Adobe Illustrator. The design is based on fluid and dynamic lines, expressing the concepts of rebirth, power, and elegance. The upward shape of the wings conveys movement, ambition, and evolution, while the clean silhouette ensures excellent readability.
The golden tone enhances the noble, prestigious, and timeless character of the symbol. This project demonstrates my ability to design logos with strong symbolic value, master graphic composition, and create impactful and memorable visual identities.`
   ,
    link: "https://www.behance.net/gallery/242241687/logo",
    linkLabel: "Find it on Behance →",
  },
      {
    title: "Logo – Graphic Design in Adobe Illustrator",
    tools: "Adobe Illustrator",
    cardImg: "projects/logo3logo.png",
    modalImg: "projects/logo3.png",
    description:
      
        `Creation of a contemporary logo designed in Adobe Illustrator, based on a circular composition of curved shapes evoking movement, harmony, and continuity. The radial organization of the elements creates a strong central focal point, enhancing the balance and readability of the symbol.
The combination of gray and gold adds elegance, subtlety, and modernity while strengthening the visual identity. The clean design allows versatile use across digital and printed media.
This project demonstrates my ability to design coherent, aesthetic, and memorable logos, as well as my mastery of vector graphic creation tools.`
   ,
    link: "https://www.behance.net/gallery/242241727/logo",
    linkLabel: "Find it on Behance →",
  },
        {
    title: "Logo – Graphic Design in Adobe Illustrator",
    tools: "Adobe Illustrator",
    cardImg: "projects/logo4logo.png",
    modalImg: "projects/logo4.png",
    description:
      
        `Creation of a modern and dynamic logo developed in Adobe Illustrator, based on a circular composition of curved shapes symbolizing movement, energy, and continuity. The alternation of orange and gray creates strong contrast and a balanced visual identity that is both professional and expressive.
The clean design ensures optimal readability and easy adaptation across various communication media. This project demonstrates my ability to create coherent visual identities, master vector tools, and translate abstract values into a strong and memorable graphic symbol.`
   ,
    link: "https://www.behance.net/gallery/242241797/logo",
    linkLabel: "Find it on Behance →",
  },
         {
    title: "Sofa / Armchair – 3D Design and Modeling in Fusion 360",
    tools: "Fusion 360",
    cardImg: "projects/sofalogo.png",
    modalImg: "projects/sofa.png",
    description:
      
        `Design and 3D modeling of an organically shaped sofa created in Fusion 360, highlighting enveloping and ergonomic forms that promote comfort and conviviality. The work on the woven texture enhances the natural and warm character of the furniture while emphasizing its volumes and curves.
The continuous and harmonious lines create a modern and welcoming silhouette. The sober color palette reinforces the elegance and visual balance of the design.
This project demonstrates my ability to design furniture with complex forms, master parametric modeling, and produce realistic and aesthetic visualizations suitable for professional presentation.`
   ,
    link: "https://www.behance.net/gallery/242241797/logo",
    linkLabel: "Find it on Behance →",
  },
  // ...add the rest (up to 32)
];

  const projectCategory = (project) => {
    if (project.category) return project.category;
    if (project.title.toLowerCase().includes('logo')) return 'graphic';
    return 'furniture';
  };

  const visibleProjects = portfolioFilter === 'all'
    ? projects
    : projects.filter(project => projectCategory(project) === portfolioFilter);

  return (
    <div className={`App craftivo-page theme-${theme} ${mobileNavOpen ? 'mobile-nav-active' : ''}`}>
 
  <header id="header" className="craftivo-header fixed-top">
    <div className="container header-inner">
      <a href="#home" className="site-logo">Mohammed Aziz Khrouf</a>

    <nav id="navmenu" className="craftivo-nav navmenu">
      <ul>
        <li><a href="#home" className="nav-link scrollto active">Home</a></li>
        <li><a href="#about" className="nav-link scrollto">About</a></li>
        <li><a href="#skills" className="nav-link scrollto">Skills</a></li>
        <li><a href="#resume" className="nav-link scrollto">Resume</a></li>
        <li><a href="#portfolio" className="nav-link scrollto">Projects</a></li>
     
  
      {/*  <li><a href="#services" class="nav-link scrollto"><i class="bx bx-server"></i> <span>Download CV</span></a></li> */}
   <li><a href="#contact" className="nav-link scrollto">Contact</a></li>
      </ul>
    </nav>
    <a className="header-cta" href="#contact">Let's talk</a>
    <button
      className="theme-toggle"
      type="button"
      onClick={() => setTheme(current => current === 'dark' ? 'light' : 'dark')}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      <i className={`bi ${theme === 'dark' ? 'bi-sun' : 'bi-moon-stars'}`}></i>
    </button>
    <button className="mobile-nav-toggle" onClick={() => setMobileNavOpen(open => !open)} aria-label="Toggle navigation" aria-expanded={mobileNavOpen}>
      <i className={`bi ${mobileNavOpen ? 'bi-x' : 'bi-list'}`}></i>
    </button>
    </div>
  </header>
  <section id="home" className="craftivo-hero d-flex flex-column justify-content-center">
    <img src={require("./linkedin1.png")} alt="Mohammed Aziz Khrouf" className="hero-background" />
    <div className="container hero-content" data-aos="fade-up" data-aos-delay="100">
      <h1>Hi, I'm Mohammed Aziz Khrouf</h1>
      <p className="hero-role">I'm a <span className="typed-role">{typedRole}</span><span className="typed-cursor" aria-hidden="true"></span></p>
 
      <div className="social-links">
   


        <a href="https://github.com/Louaykharouf26" className="google-plus" aria-label="GitHub"><i className="bx bxl-github"></i></a>
        <a href="https://www.linkedin.com/in/mohammed-aziz-khrouf-b141a9319/" className="linkedin" aria-label="LinkedIn"><i className="bx bxl-linkedin"></i></a>
        <a href="https://www.behance.net/azizkharouf" className="medium" aria-label="Behance"><i className="bi bi-behance"></i></a>
 
      </div>
    </div>
</section>
<main id="main">
<section id="about" className="about craftivo-about">
  <div className="container" data-aos="fade-up">
    <div className="row gy-5">
      <div className="col-lg-4">
        <div className="profile-card">
          <div className="profile-header">
            <div className="profile-avatar">
              <img src={require("./linkedin1.png")} alt="Mohammed Aziz Khrouf" />
              <span className="status-indicator"></span>
            </div>
            <h3>Mohammed Aziz Khrouf</h3>
            <span className="role">Furniture Designer | Interior Designer</span>
          </div>
          <div className="profile-actions">
            <a href={require("./AzizCV.pdf")} download className="btn-primary"><i className="bi bi-download"></i> Download CV</a>
            <a href="#contact" className="btn-secondary"><i className="bi bi-envelope"></i> Contact</a>
          </div>
          <div className="social-connect">
            <a href="https://www.linkedin.com/in/mohammed-aziz-khrouf-b141a9319/" aria-label="LinkedIn"><i className="bi bi-linkedin"></i></a>
            <a href="https://github.com/Louaykharouf26" aria-label="GitHub"><i className="bi bi-github"></i></a>
            <a href="https://www.behance.net/azizkharouf" aria-label="Behance"><i className="bi bi-behance"></i></a>
          </div>
        </div>
      </div>

      <div className="col-lg-8">
        <div className="content-wrapper">
          <div className="bio-section">
            <div className="section-tag">About Me</div>
            <h2>Transforming Ideas into Digital Reality</h2>
            <p><strong>Product Design student at ISAMS</strong>, passionate about creating new product ideas and graphic designs that combine creativity and functionality.</p>
            <p>I enjoy working on <strong>product concepts</strong>, <strong>logos</strong>, and <strong>visual designs</strong>, as well as preparing projects for manufacturing processes such as <strong>CNC</strong> and <strong>laser cutting</strong>.</p>
            <p>Motivated, detail-oriented, and always eager to learn and improve my <strong>design skills</strong>.</p>
          </div>
          <div className="details-grid">
            <div className="detail-item"><i className="bi bi-briefcase"></i><div className="detail-content"><span>Profession</span><strong>Furniture Designer</strong></div></div>
            <div className="detail-item"><i className="bi bi-mortarboard"></i><div className="detail-content"><span>Degree</span><strong>Bachelor Degree in Furniture Design</strong></div></div>
            <div className="detail-item"><i className="bi bi-geo-alt"></i><div className="detail-content"><span>Based In</span><strong>Tunis, Tunisia</strong></div></div>
            <div className="detail-item"><i className="bi bi-envelope"></i><div className="detail-content"><span>Email</span><strong>kharoufaziz12@gmail.com</strong></div></div>
            <div className="detail-item"><i className="bi bi-phone"></i><div className="detail-content"><span>Phone</span><strong>+216 29 322 889</strong></div></div>
            <div className="detail-item"><i className="bi bi-calendar-check"></i><div className="detail-content"><span>Availability</span><strong>Open to collaboration / Freelance</strong></div></div>
          </div>
          <div className="skills-showcase">
            <div className="section-tag">Core Skills</div>
            <p>Product Design – Furniture Design – Interior Design- 3D Modeling – Graphic Design – CNC &amp; Laser Cutting – Visual Communication – AutoCAD – Adobe Illustrator – SketchUp - D5 Render</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="legacy-about" aria-hidden="true">
  <div className="container" data-aos="fade-up">
    <div className="section-title">
      <span className="subtitle">About Me</span>
      <h2>About</h2>
     <p>
  <strong>Product Design student at ISAMS</strong>, passionate about creating new
  product ideas and graphic designs that combine creativity and functionality.
  <br />
  I enjoy working on <strong>product concepts</strong>, <strong>logos</strong>,
  and <strong>visual designs</strong>, as well as preparing projects for
  manufacturing processes such as <strong>CNC</strong> and
  <strong>laser cutting</strong>.
  <br />
  Motivated, detail-oriented, and always eager to learn and improve my
  <strong>design skills</strong>.
</p>

    </div>

    <div className="row gy-5 craftivo-about-grid">
      {/* Image */}
      <div className="col-lg-4 text-center profile-card">
        <img
          src={require("./linkedin1.png")}
          alt="Mohammed Aziz Khrouf"
          className="profile-avatar-image"
        />
      </div>

      {/* Content */}
      <div className="col-lg-8 pt-4 pt-lg-0 content content-wrapper">
<h3>
  Furniture Designer | Interior Designer 
</h3>


        <p className="fst-italic">
         Product Design – Furniture Design – 3D Modeling – Graphic Design – CNC & Laser Cutting – Visual Communication - AutoCAD - Adobe Illustratore - SketchUP
        </p>

        <div className="row mt-4">
  {/* Details */}
  <div className="col-lg-12">
    <h4>Details</h4>
    <div className="row">
      <div className="col-md-6">
        <ul>
          <li>
            <i className="bi bi-chevron-right"></i>{" "}
            <strong>City:</strong>{" "}
            <span>Tunis, Tunisia</span>
          </li>
          <li>
            <i className="bi bi-chevron-right"></i>{" "}
            <strong>Phone:</strong>{" "}
            <span>+216 29 322 889</span>
          </li>
        </ul>
      </div>

      <div className="col-md-6">
        <ul>
          <li>
            <i className="bi bi-chevron-right"></i>{" "}
            <strong>Degree:</strong>{" "}
            <span>Bachelor Degree in Furniture Design</span>
          </li>
          <li>
            <i className="bi bi-chevron-right"></i>{" "}
            <strong>Availability:</strong>{" "}
            <span>Open to collaboration / Freelance</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

      </div>
    </div>
  </div>
</section>



<section id="skills" className="skills section-bg">
  <div className="container" data-aos="fade-up">
    <div className="section-title">
      <span className="subtitle">Design Toolkit</span>
      <h2>Skills</h2>
      <p>
        Here is a highlight of the tools I use for 3D modeling and furniture design and interior design.
      </p>
    </div>

    {/* Tools marquee */}
    <div className="tech-slider">
      <div className="tech-track">
      {[
  "autocad.png",
  "canva.png",
  "corel.png",
  "fusion.svg",
  "illustrator.png",
  "Photoshop-logo.png",
  "sketchup.jpg",
  "vectorMagic.jpg",
]
  .concat([
    "autocad.png",
    "canva.png",
    "corel.png",
    "fusion.svg",
    "illustrator.png",
    "Photoshop-logo.png",
    "sketchup.jpg",
    "vectorMagic.jpg",
  ])
  .map((icon, idx) => (
    <img
      key={idx}
      src={`/icons/${icon}`}
      alt={icon.replace(/[-_]/g, " ").replace(/\.(png|svg|jpg)$/i, "")}
      loading="lazy"
    />
  ))}

         
      </div>
    </div>

  
  </div>
</section>


        <section id="resume" className="resume craftivo-resume">
          <div className="container" data-aos="fade-up">
            <div className="resume-titlebar">
              <div>
                <span className="resume-eyebrow">My Resume</span>
                <h2>Education &amp; Professional Experience</h2>
                <p>A summary of my academic background and practical design journey.</p>
              </div>
              <a href={require("./AzizCV.pdf")} download className="resume-download"><i className="bi bi-download"></i> Download My Resume</a>
            </div>

            <div className="row gy-5">
              <div className="col-lg-6">
                <div className="resume-section-header">
                  <span className="section-badge">Experience</span>
                  <h2>Professional Journey</h2>
                  <p>Furniture, interior, product, and graphic design experience focused on functional concepts and production-ready results.</p>
                </div>

                <div className="experience-cards">
                  <article className="exp-card featured">
                    <div className="exp-card-top"><span className="company-icon"><i className="bi bi-house-door"></i></span><span className="current-badge">Current</span></div>
                    <h3>Interior Designer</h3><p className="company-name">Freelance</p><span className="duration">June 2026</span>
                    <p className="description">Design of a kitchen for a new house using SketchUp and D5 Render.</p>
                    <div className="skill-tags"><span>Interior Design</span><span>SketchUp</span><span>D5 Render</span></div>
                  </article>

                  <article className="exp-card">
                    <div className="exp-card-top"><span className="company-icon"><i className="bi bi-lamp"></i></span></div>
                    <h3>Furniture Designer Intern</h3><p className="company-name">BoxDesign, Gabès, Tunisia</p><span className="duration">February 2026 – June 2026</span>
                    <p className="description">Designed a minimalist, functional chaise longue with attention to modularity, comfort, space optimization, technical requirements, and manufacturing limitations.</p>
                  </article>

                  <article className="exp-card">
                    <div className="exp-card-top"><span className="company-icon"><i className="bi bi-vector-pen"></i></span></div>
                    <h3>Graphic Designer Intern</h3><p className="company-name">OriWOOD, Gabès, Tunisia</p><span className="duration">July 2025 – August 2025</span>
                    <p className="description">Designed logos and vector-based product components optimized for laser cutting and engraving while respecting precision, scale, and material constraints.</p>
                  </article>

                  <article className="exp-card">
                    <div className="exp-card-top"><span className="company-icon"><i className="bi bi-box"></i></span></div>
                    <h3>Product Designer (Freelance)</h3><p className="company-name">OriWOOD, Gabès, Tunisia</p><span className="duration">April 2025 – May 2025</span>
                    <p className="description">Converted client images into accurate vector-ready designs for CNC machining and optimized them for tolerances, tool paths, and material limits.</p>
                  </article>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="resume-section-header">
                  <span className="section-badge">Education</span>
                  <h2>Academic Background</h2>
                  <p>Academic training in furniture and product design supported by creative concept development and manufacturing-oriented digital tools.</p>
                </div>

                <div className="education-timeline">
                  <article className="education-item">
                    <span className="timeline-marker"><i className="bi bi-mortarboard-fill"></i></span>
                    <div className="education-card">
                      <div className="education-meta"><span className="year-range">2023 – 2026</span><span className="degree-level">Bachelor</span></div>
                      <h3>Bachelor’s Degree in Furniture &amp; Product Design</h3>
                      <p className="institution">Higher Institute of Arts and Crafts of Sfax (ISAMS)</p>
                      <p className="description">Specialized in product and furniture design using digital tools such as AutoCAD, Illustrator, and Canva, with a focus on creative concept development and manufacturing-oriented design.</p>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="legacy-resume">
      <div class="container" data-aos="fade-up">
      <div class="section-title">
          <span className="subtitle">My Journey</span>
          <h2>Resume</h2>
<a
  href={require("./AzizCV.pdf")}
  download
  className="btn btn-outline-dark"
>
  Download my resume for more details
</a>



          </div>
          <div class="row">
          <div class="col-lg-6" data-aos="fade-up">
            <h3 class="resume-title">Summary</h3>
            <div class="resume-item pb-0">
              <h4>Mohammed Aziz Khrouf</h4>
              <p><em>
Furniture Designer, Interior Designer, 3D Modeling and Graphic Design Explorer
                </em></p>
              <ul>
                <li>Tunis , Tunisia</li>
                <li>+216 29 322 889 </li>
                <li>kharoufaziz12@gmail.com</li>
              </ul>
            </div>
            <h3 class="resume-title">Education</h3>
         <div class="resume-item">
  <h4>Bachelor’s Degree in Furniture & Product Design</h4>
  <h5>2023 – 2026</h5>
  <p><em>Higher Institute of Arts and Crafts of Sfax (ISAMS)</em></p>
  <p>
    Specialized in product and furniture design using digital tools such as AutoCAD, Illustrator, and Canva, with a focus on creative concept development and manufacturing-oriented design.
  </p>
</div>


            </div>
            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
  <h3 class="resume-title">Professional Experience</h3>
    <div class="resume-item">
    <h4>Interior Designer </h4>
    <h5>June 2026</h5>
    <p><em>Freelance</em></p>
    <p>
      • Design of a kitchen for a new house <br />
      • SketchUp, D5 render
    </p>
  </div>
  <div class="resume-item">
    <h4>Furniture Designer Intern</h4>
    <h5>February 2026 – June 2026</h5>
    <p><em>BoxDesign, Gabès, Tunisia</em></p>
    <p>
      • Design of a minimalist and functional chaise longue, integrating modularity, comfort, and space optimization.<br />
      • Market research, study of the chair components, chair design, and implementation of this design.<br />
      • Adapted designs according to technical requirements and manufacturing limitations.<br />
      • Collaborated with production teams to ensure design feasibility and the quality of the final result.
    </p>
  </div>
  <div class="resume-item">
    <h4>Graphic Designer Intern</h4>
    <h5>July 2025 – August 2025</h5>
    <p><em>OriWOOD, Gabès, Tunisia</em></p>
    <p>
      • Designed logos and product components adapted for laser cutting and engraving.<br />
      • Prepared vector-based files optimized for laser cutting (precision, scale, material constraints).<br />
      • Adapted designs according to technical requirements and manufacturing limitations.<br />
      • Collaborated with production teams to ensure design feasibility and quality output.
    </p>
  </div>
 <div class="resume-item">
  <h4>Product Designer (Freelance)</h4>
  <h5>April 2025 – May 2025</h5>
  <p><em>OriWOOD, Gabès, Tunisia</em></p>
  <p>
    • Converted client-provided images into pixelated and vector-ready designs suitable for CNC machining.<br />
    • Optimized designs to meet CNC machine constraints (tolerances, tool paths, material limits).<br />
    • Converted raster images into clean vector files using image vectorization techniques (Vector Magic workflow).<br />
    • Ensured design accuracy and manufacturing compatibility for production processes.
  </p>
</div>


            </div>
            </div>
            
        </div>
        </section>
        <section id="portfolio" className="portfolio section-bg craftivo-portfolio">
          <div className="container" data-aos="fade-up">
            <div className="portfolio-heading">
              <span className="portfolio-eyebrow">Selected Work</span>
              <h2>My Design Portfolio</h2>
              <p>Explore my furniture, product, graphic, and upcoming interior design projects.</p>
            </div>

            <div className="portfolio-filters" role="group" aria-label="Project filters">
              <button type="button" className={portfolioFilter === 'all' ? 'active' : ''} onClick={() => setPortfolioFilter('all')}>All Work</button>
              <button type="button" className={portfolioFilter === 'furniture' ? 'active' : ''} onClick={() => setPortfolioFilter('furniture')}>Furniture Design</button>
              <button type="button" className={portfolioFilter === 'interior' ? 'active' : ''} onClick={() => setPortfolioFilter('interior')}>Interior Design</button>
            </div>

            {visibleProjects.length > 0 ? (
              <div className="portfolio-gallery">
                {visibleProjects.map((project, index) => (
                  <article className="portfolio-piece" key={`${project.title}-${index}`}>
                    <button type="button" className="portfolio-image" onClick={() => { setSelectedProject(project); setShowProjectModal(true); }}>
                      <img className={project.cardClass || ''} src={project.cardImg} alt={project.title} loading="lazy" />
                      <span className="portfolio-overlay">
                        <span className="project-category">{projectCategory(project) === 'furniture' ? 'Furniture Design' : projectCategory(project) === 'interior' ? 'Interior Design' : 'Graphic Design'}</span>
                        <strong>{project.title}</strong>
                        <span className="view-project"><i className="bi bi-arrow-up-right"></i></span>
                      </span>
                    </button>
                    <div className="portfolio-meta">
                      <div><span>{project.tools}</span><span>{projectCategory(project) === 'interior' ? 'Interior' : projectCategory(project) === 'furniture' ? 'Design' : 'Identity'}</span></div>
                      <button type="button" onClick={() => { setSelectedProject(project); setShowProjectModal(true); }}>View project <i className="bi bi-arrow-right"></i></button>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="portfolio-empty">
                <i className="bi bi-house-add"></i>
                <h3>Interior Design Projects Coming Soon</h3>
                <p>This category is ready for the interior design projects you will add next.</p>
              </div>
            )}
          </div>
        </section>

        <section className="legacy-portfolio">
      <div class="container" data-aos="fade-up">
      <div class="section-title">
          <span className="subtitle">Selected Work</span>
          <h2>Projects</h2>
          <p>Here is some of my projects the code of each project is in my github</p>
          </div>
      
{/*    <div class="row">
<div className="col-lg-6" data-aos="fade-up">


<div className="col-lg-6" data-aos="fade-up">
  <div 
    className="project-card" 
    onClick={() => setShowCtfModal(true)}
    style={{ cursor: 'pointer' }}
  >
    <img src="projects/chaise-removebg-preview.png" className="project-card-img" alt="CTF Platform" />
    <div className="project-card-body">
      <h4>Multifunctional Desk – 3D Modeling in AutoCAD
</h4>
<p>Tools : AutoCAD</p>
      <p>Click to view details</p>
    </div>
  </div>

  {/* Modal */}
  {/*<Modal 
    show={showCtfModal} 
    onHide={() => setShowCtfModal(false)}
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title>Multifunctional Desk</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <img 
        src="projects/Desk1.png" 
        alt="Multifunctional Desk" 
        className="img-fluid mb-3" 
      />
 <p>This project represents a multifunctional desk that I fully designed and modeled in 3D using AutoCAD. The goal was to create an ergonomic, compact, and aesthetic piece of furniture adapted to a modern workspace.
The design combines several features: a main work surface with curved lines for improved comfort, integrated upper shelves for document and object storage, a side cabinet with an ergonomic handle, and lower drawers providing additional storage space.
The choice of colors and materials aims to create a balance between simplicity, modernity, and warmth, while highlighting the volumes and details of the furniture.
This project allowed me to develop my skills in 3D modeling, furniture design, proportion management, and project visualization. It demonstrates my ability to independently design a product from the initial concept to the final representation.</p>
    </Modal.Body>
    <Modal.Footer>
      <p><strong>Tools:</strong> AutoCAD</p>
      <p>
        <a 
          href="https://www.behance.net/gallery/241986851/Modlisation-dun-Bureau-multifonction" 
          target="_blank" 
          rel="noopener noreferrer"
          className="github-link"
        >
          Find it in Behance →
        </a>
      </p>
    </Modal.Footer>
  </Modal>
  
</div>*/}

<div className="projects-grid">
  {projects.map((p, idx) => (
    <div
      key={idx}
      className="project-card"
      onClick={() => {
        setSelectedProject(p);
        setShowProjectModal(true);
      }}
      style={{ cursor: "pointer" }}
    >
      <img src={p.cardImg} className="project-card-img" alt={p.title} />
      <div className="project-card-body">
        <h4>{p.title}</h4>
        <p>Tools : {p.tools}</p>
        <p>Click to view details</p>
      </div>
    </div>
  ))}
</div>

<Modal
  show={showProjectModal}
  onHide={() => setShowProjectModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>{selectedProject?.title}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedProject?.modalImg && (
      <img
        src={selectedProject.modalImg}
        alt={selectedProject.title}
        className="img-fluid mb-3"
      />
    )}
    <p>{selectedProject?.description}</p>
  </Modal.Body>

  <Modal.Footer className="justify-content-between">
    <p className="m-0">
      <strong>Tools:</strong> {selectedProject?.tools}
    </p>

    {selectedProject?.link && (
      <a
        href={selectedProject.link}
        target="_blank"
        rel="noopener noreferrer"
        className="github-link"
      >
        {selectedProject.linkLabel || "View project →"}
      </a>
    )}
  </Modal.Footer>
</Modal>

           
            </div>

              
                
          
  {/*  </div></div> */}
             
        
    
      </section>
    {/*  <section id="services" class="services">
      <div class="container">

        <div class="section-title">
          <h2>Download CV</h2>
          <p>Here u can Download my CV for more details </p>
        </div>
<center>
        
          <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up">
          <a href={require("./LouaykharoufCV.pdf")}  download>
  <img src={require("./portfoliodownload.png")} alt="CV" width="104" height="142"></img>
          </a>
          </div>
          </center>
          </div>
          
    </section>
     */}
   

<section id="contact" className="contact">
  <div className="container" data-aos="fade-up">
    <div className="section-title">
      <span className="subtitle">Get In Touch</span>
      <h2>Contact</h2>
      <p>
        Feel free to reach out for collaboration, research discussions, or
        professional opportunities.
      </p>
    </div>

    <div className="row">
      {/* Left: Contact Information */}
      <div className="col-lg-4">
        <div className="info">
          <div className="address">
            <i className="bi bi-geo-alt"></i>
            <h4>Location:</h4>
            <p>Tunis, Tunisia</p>
          </div>

          <div className="email">
            <i className="bi bi-envelope"></i>
            <h4>Email:</h4>
            <p>kharoufaziz12@gmail.com</p>
          </div>

          <div className="phone">
            <i className="bi bi-phone"></i>
            <h4>Call:</h4>
            <p>+216 29 322 889</p>
          </div>
        </div>
      </div>

      {/* Right: Netlify Contact Form */}
      <div className="col-lg-8 mt-5 mt-lg-0">

        {/* Success message */}
        {typeof window !== "undefined" &&
          window.location.hash.includes("success=true") && (
            <div className="alert alert-success mb-4" role="alert">
              ✅ Your message has been sent successfully. I’ll get back to you
              soon.
            </div>
          )}

        <form
          name="contact"
          method="POST"
          action="/?success=true#contact"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          className="php-email-form"
        >
          {/* Netlify required hidden input */}
          <input type="hidden" name="form-name" value="contact" />

          {/* Honeypot field */}
          <p style={{ display: "none" }}>
            <label>
              Don’t fill this out if you’re human:{" "}
              <input name="bot-field" />
            </label>
          </p>

          <div className="row">
            <div className="col-md-6 form-group">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Your Name"
                required
              />
            </div>

            <div className="col-md-6 form-group mt-3 mt-md-0">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Your Email"
                required
              />
            </div>
          </div>

          <div className="form-group mt-3">
            <input
              type="text"
              name="subject"
              className="form-control"
              placeholder="Subject"
              required
            />
          </div>

          <div className="form-group mt-3">
            <textarea
              name="message"
              rows="5"
              className="form-control"
              placeholder="Message"
              required
            ></textarea>
          </div>

          <div className="text-center mt-4">
            <button type="submit">Send Message</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>



  </main>
  <button className={`scroll-top ${showScrollTop ? 'active' : ''}`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Scroll to top">
    <i className="bi bi-arrow-up-short"></i>
  </button>
    </div>
  );
}

export default App;
